/* eslint-disable react/prop-types */
/* eslint-disable no-undef */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-prototype-builtins */

import React, { useEffect } from 'react';

import qs from 'qs';
import axios from 'axios';
import i18n from 'i18n-js';
import moment from 'moment';
import { sumBy } from 'lodash';
import { usePrevious } from 'hooks';
import { integrations } from 'config';
import Cookies from 'universal-cookie';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useFormikContext } from 'formik';
import { locales } from '../config/locales';
import routes from 'components/Sidebar/routes';
import { makeStyles } from '@material-ui/core/styles';
import { isEqual, isArray, isObject, transform } from 'lodash';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';

/**
 * Get environment to be used
 */
export const getEnvironment = () => {
  const { hostname } = window.location;

  // Get environment from url
  const hostnameParts = hostname.split('.').shift().split('-');
  // Use env variable if hostname is localhost
  if (hostname.includes('localhost')) {
    return integrations.stage;
  }
  // Validate if environment is alpha, beta, staging and others
  else if (hostnameParts.length > 1) {
    return hostnameParts[hostnameParts.length - 1];
  }

  // If there is not an environment, then is prod
  return 'production';
};

/**
 * Gets the region of a deployment based on the host url
 * @returns {string} Deployment region
 */
const getRegion = () => {
  const { hostname } = window.location;
  const subdomains = hostname.split('.').shift().split('-');

  // Get subdomains based on the hostname or use North America as default
  return subdomains[0] === 'localhost'
    ? 'localhost'
    : subdomains?.length > 1
      ? subdomains[subdomains.length - 1]
      : 'na';
};

/**
 * Get cubejs url according to environment
 */
export const getCubeUrl = (type = null) => {
  const { cubeUrl, cubeUrl2, cubeUrlRER, deployment } = integrations;
  let cubeUrlByVersion =
    validateReservationEngineVersionMultiUrl({
      V1: cubeUrl,
      V2: cubeUrlRER,
    }) || cubeUrl;

  if (type == 'reporting') {
    cubeUrlByVersion = cubeUrl2;
  }
  // Validate if this is localhost
  if (deployment === 'production') {
    const region = getRegion();
    return cubeUrlByVersion?.replace('{{env}}', `-${region}`);
  } else {
    // Get environment from url
    const env = getEnvironment();
    return cubeUrlByVersion?.replace('{{env}}', `-${env}`);
  }
};

/**
 * Get api url according to environment
 */
export const getApiUrl = () => {
  const { apiUrl, deployment } = integrations;
  // Validate if this is localhost
  if (deployment === 'production') {
    const region = getRegion();
    return apiUrl.replace('{{env}}', `-${region}`);
  } else {
    // Get environment from url
    const env = getEnvironment();
    return apiUrl.replace('{{env}}', `-${env}`);
  }
};

/**
 * Get auth url according to environment
 */
export const getAuthUrl = () => {
  const { authServerUrl, deployment } = integrations;
  if (deployment === 'production') {
    return authServerUrl;
  } else {
    // Get environment from url
    const env = getEnvironment();
    return authServerUrl.replace('{{env}}', `-${env}`);
  }
};

/**
 * Get LMKB url according to environment
 */
export const getLMKBUrl = () => {
  const { deployment } = integrations;
  if (deployment === 'production') {
    return 'https://knowledgebase.launchmobility.com/';
  } else {
    return 'https://docs-public-dev.lminc.io/';
  }
};

/**
 * Get auth redirect URL
 */
export const getAuthRedirectUrl = () => {
  const { hostname } = window.location;
  // Use env variable if hostname is localhost
  if (hostname.includes('localhost')) {
    return `http://${hostname}:3000`;
  }

  return 'https://' + hostname;
};

/**
 * Validate FA
 */
export const hasFusionAuthEnabled = localStorage.getItem('fa_enabled') === 'true';

/**
 * Get error message from api response
 * @param {any} error
 * @param {object} options
 * @param {boolean} all
 */
export const getErrorMessage = (error, options = {}, all = false) => {
  const details = error?.details;
  let message;

  if (Array.isArray(details) && !options.fullObject && !all) {
    message = details[0].message;
    return message;
  }

  if (!details) {
    message =
      error?.key === 'DEBUGGING' || !error?.message
        ? 'There was an unexpected error processing the request. Please try again.'
        : error?.message;
    return message;
  }

  return details;
};

export const getFAErrorMessage = (error) => {
  const fieldErrors = error?.fieldErrors;
  let message;

  if (fieldErrors) {
    // Get the first error message
    const firstField = Object.keys(fieldErrors)[0];
    if (Array.isArray(fieldErrors[firstField])) {
      message = fieldErrors[firstField][0].message;
      return message;
    }
  }

  if (!fieldErrors) {
    message =
      error?.key === 'DEBUGGING' || !error?.message
        ? i18n.t('common.generic_error')
        : error?.message;
    return message;
  }

  return fieldErrors;
};

export const getSubdomain = (hostname) => {
  const regexParse = new RegExp('[a-z-0-9]{2,63}.[a-z.]{2,5}$');
  const urlParts = regexParse.exec(hostname);
  return hostname.replace(urlParts[0], '').slice(0, -1);
};

export const getServicesByType = (orgs) => {
  const data =
    orgs
      ?.filter(
        (val) =>
          // get only service and owner type organizations
          val.organization?.organization_type === 'SERVICE' ||
          val.organization?.organization_type === 'OWNER'
      )
      .map((val) => {
        // get only organization fields
        return { ...val.organization };
      }) || [];
  return data;
};

/**
 * Return object with pagination data
 * @param {object} headers
 */
export const parsePagination = (headers = {}) => {
  const pagination = {
    pages: parseInt(headers['pagination-pages'] || 0),
    totalRows: parseInt(headers['pagination-count'] || 0),
    currentPage: parseInt(headers['pagination-page'] || 0),
    nextPage: headers['pagination-has-next'] === 'True' ? true : false,
    prevPage: headers['pagination-has-prev'] === 'True' ? true : false,
  };
  return pagination;
};

/**
 * Get service groups services
 * @param {*} data
 * @param {*} services
 */
export const formatVGServices = (data, services) => {
  let orgs = data.map((val) => val.organization_id);
  orgs = [...new Set(orgs)];

  const activeService = services.filter(function (service) {
    return orgs.includes(service.id);
  });

  return activeService;
};

export const getVehicleActions = (configBrokers, vehicleBrokers) => {
  const actions = [];
  const omit = ['ENABLE'];

  Object.keys(vehicleBrokers).forEach((key) => {
    const broker = configBrokers[key];
    if (broker && broker.actions) {
      broker.actions.map((action) => {
        // validate if the action does not exist
        if (omit.indexOf(action) === -1 && actions.indexOf(action) === -1) actions.push(action);
        return true;
      });
    }
  });

  return actions;
};

/**
 * Find difference between two objects
 * @param  {object} origObj - Source object to compare newObj against
 * @param  {object} newObj  - New object with potential changes
 * @return {object} differences
 */
export const diffObjects = (origObj, newObj) => {
  function changes(newObj, origObj) {
    let arrayIndexCounter = 0;
    return transform(newObj, function (result, value, key) {
      if (!isEqual(value, origObj[key])) {
        let resultKey = isArray(origObj) ? arrayIndexCounter++ : key;
        result[resultKey] =
          isObject(value) && isObject(origObj[key]) ? changes(value, origObj[key]) : value;
      }
    });
  }
  return changes(newObj, origObj);
};

/**
 * Format amount value
 * @param  {object} amount
 */
export const formatAmount = (amount = 0, fractionDigits = 2) => {
  return parseFloat(amount / 100).toFixed(fractionDigits);
};

/**
 * Get reservations status
 * @param  {array} data Reservations data
 */
export const determineStatusAndUsedReservation = (data) => {
  Array.isArray(data) &&
    data.forEach((element, index, array) => {
      let status = 'AVAILABLE';
      let activeReservation = null;
      let late = false;
      if (element.vehicle_status === 'INSHOP') {
        status = 'INSHOP';
      } else if (element.vehicle_status === 'ACTIVE') {
        let inProgressReservation = getReservationWithStatus(element.reservations, 'INPROGRESS');
        let reservedReservation = getReservationWithStatus(element.reservations, 'RESERVED');

        if (inProgressReservation) {
          status = 'INPROGRESS';
          activeReservation = inProgressReservation;
          late = moment(activeReservation.end_reserved) < moment();
        } else if (reservedReservation) {
          status = 'RESERVED';
          activeReservation = reservedReservation;
          late = moment(activeReservation.start_reserved) < moment();
        }
      }

      array[index].status = status;
      array[index].activeReservation = activeReservation;
      array[index].late = late;
    });
  return data;
};
/**
 * Get reservations with status
 * @param  {array} reservations Reservations data
 * @param  {string} status Status
 */
const getReservationWithStatus = (reservations, status) => {
  return reservations ? reservations.find((reservation) => reservation.status === status) : null;
};
/**
 * Get map icons
 * @param  {object} data Data
 * @param  {string} type Type
 */
export const getMapIcons = (data, type) => {
  let icon;

  switch (data?.status) {
    case 'AVAILABLE':
      icon =
        type === 'bike'
          ? require('assets/img/map-icons/bike/available.png')
          : type === 'scooter'
            ? require('assets/img/map-icons/scooter/available.png')
            : require('assets/img/map-icons/car/available.png');
      break;
    case 'INPROGRESS':
      if (data?.late) {
        icon =
          type === 'bike'
            ? require('assets/img/map-icons/bike/latereturn.png')
            : type === 'scooter'
              ? require('assets/img/map-icons/scooter/latereturn.png')
              : require('assets/img/map-icons/car/latereturn.png');
      } else {
        icon =
          type === 'bike'
            ? require('assets/img/map-icons/bike/inuse.png')
            : type === 'scooter'
              ? require('assets/img/map-icons/scooter/inuse.png')
              : require('assets/img/map-icons/car/inuse.png');
      }
      break;
    case 'INSHOP':
      icon =
        type === 'bike'
          ? require('assets/img/map-icons/bike/inshop.png')
          : type === 'scooter'
            ? require('assets/img/map-icons/scooter/inshop.png')
            : require('assets/img/map-icons/car/inshop.png');
      break;
    case 'RESERVED':
      if (data?.late) {
        icon =
          type === 'bike'
            ? require('assets/img/map-icons/bike/latestart.png')
            : type === 'scooter'
              ? require('assets/img/map-icons/scooter/latestart.png')
              : require('assets/img/map-icons/car/latestart.png');
      } else {
        icon =
          type === 'bike'
            ? require('assets/img/map-icons/bike/reserved.png')
            : type === 'scooter'
              ? require('assets/img/map-icons/scooter/reserved.png')
              : require('assets/img/map-icons/car/reserved.png');
      }
      break;
    default:
      icon = require('assets/img/map-icons/car/available.png');
  }

  return icon;
};

export const capitalize = (str) => {
  if (!str) {
    return '';
  }
  if (str.length > 0) {
    str = str.split(' ');
    for (let i = 0, x = str.length; i < x; i++) {
      if (str[i][0]) {
        str[i] = str[i][0]?.toUpperCase() + str[i]?.substr(1);
      }
    }
    return str.join(' ');
  }
  return str;
};

export const keyToTitle = (key) => capitalize(key.split('_').join(' '));

/**
 * Force timezone on a date object or a moment object
 * @param {date} date Date to convert to a moment-timezone object
 *
 */
export const forceTimezone = (date) => {
  let timezone = moment().tz();
  if (!timezone) {
    timezone = 'US/Pacific';
    moment.tz.setDefault(timezone);
  }

  if (moment.isMoment(date)) {
    return date.tz(timezone, true);
  }
};

export const getTimezoneDate = (date, timezone, format = 'YYYY-MM-DD HH:mm:ss') => {
  return timezone
    ? // the pattern yyyy-MM-dd isn't an officially supported format for Date constructor
      // Firefox/Chrome seems to support it, but don't count on other browsers doing the same.
      new Date(moment(date).tz(timezone).format(format).replace(/-/g, '/'))
    : new Date(moment(date));
};

export const handleShowError = (name, errors, touched, asyncErrors) => {
  if (asyncErrors) {
    return asyncErrors;
  } else if (errors && errors[name] && touched[name]) {
    return errors[name];
  }
};

export const handleError = (name, errors, touched, asyncErrors) => {
  if (asyncErrors || (errors && errors[name] && touched && touched[name])) {
    return true;
  }
};

/**
 * Get query params
 * @param {object} query
 */
export const getParams = (query) => {
  const params = new URLSearchParams();
  Object.entries(query).map(([key, value]) => {
    if (Array.isArray(value)) return value.map((item) => params.append(key, item));
    else return params.append(key, value);
  });
  return params;
};

export const FormChanges = ({ initialValues, onSave }) => {
  // Grab values from context
  const { values } = useFormikContext();
  const prevValue = usePrevious(values);

  useEffect(() => {
    if (!isEqual(prevValue, values)) {
      if (!isEqual(values, initialValues)) {
        onSave(true);
      } else {
        onSave(false);
      }
    }
  }, [values, initialValues, prevValue, onSave]);
  return null;
};

/**
 * This function receive a non nested object with a list of parameters and creates a query string.
 *
 * @param {*} params A plain object with the parameters
 * @returns Query string
 */

export const toQueryString = (params) => {
  const paramList = Object.keys(params).reduce((acc, key) => {
    // If the value of the object is an array we flatten in to multiple entries.
    if (Array.isArray(params[key])) {
      acc = acc.concat(params[key].map((id) => [key, id]));
    } else {
      acc.push([key, params[key]]);
    }
    return acc;
  }, []);
  const urlParams = new URLSearchParams(paramList);
  return `?${urlParams.toString()}`;
};

/**
 * Get dynamic link for an element
 * @param {*} item
 * @param {*} type
 */
export const getDynamicLink = (item, value, type, className, showId, fallback) => {
  const id = showId ? ' #' + value : '';
  switch (type) {
    case 'ReservationDriver':
      return (
        <Link className={className} to={buildUrl(`/reservations/${value}`)}>
          {item}
          {id}
        </Link>
      );
    case 'OwnerVehicleGroup':
      return (
        <Link className={className} to={buildUrl(`/fleets/${value}`)}>
          {fallback ? fallback?.replace('VehicleGroup', 'Fleet') : value}
        </Link>
      );
    case 'Vehicle':
      return (
        <Link className={className} to={buildUrl(`/vehicles/${value}`)}>
          {item}
          {id}
        </Link>
      );
    case 'Driver':
      return (
        <Link className={className} to={buildUrl(`/customers/${value}`)}>
          {item}
          {id}
        </Link>
      );
    case 'billing':
      return (
        <Link className={className} to={buildUrl(`/billing/${value}`)}>
          {item}
          {id}
        </Link>
      );
    case 'Invoice':
      return (
        <Link className={className} to={buildUrl(`/invoices/${value}`)}>
          {item}
          {id}
        </Link>
      );
    case 'InvoicePreview':
      return (
        <Link className={className} to={buildUrl(`/bills/${value}`)}>
          {item}
          {id}
        </Link>
      );
    case 'Subscription':
      return (
        <Link className={className} to={buildUrl(`/subscriptions/${value}`)}>
          {item}
          {id}
        </Link>
      );
    case 'ConditionalInstance':
      return (
        <Link className={className} to={buildUrl(`/alarms/${value}`)}>
          {item}
          {id}
        </Link>
      );
    case 'Alarm':
      return (
        <Link className={className} to={buildUrl(`/alarms/${value}`)}>
          {item}
          {id}
        </Link>
      );
    case 'Payment':
      return (
        <Link className={className} to={buildUrl(`/payments/${value}`)}>
          {item}
          {id}
        </Link>
      );
    case 'AccountStatement':
      return (
        <Link className={className} to={buildUrl(`/account-statement/${value}`)}>
          {item}
          {id}
        </Link>
      );
    default:
      return item;
  }
};
/**
 * Get dynamic route of the source
 * @param {string} type Source type
 * @param {*} type Source id
 */
export const getDynamicRoute = (type, id) => {
  switch (type) {
    case 'ReservationDriver':
      return buildUrl(`/reservations/${id}`);
    case 'Vehicle':
      return buildUrl(`/vehicles/${id}`);
    case 'Driver':
      return buildUrl(`/customers/${id}`);
    case 'User':
      return buildUrl(`/customers/${id}`);
    case 'Invoice':
      return buildUrl(`/invoices/${id}`);
    case 'Subscription':
      return buildUrl(`/subscriptions/${id}`);
    case 'ConditionalInstance':
      return buildUrl(`/alarms/${id}`);
    case 'Alarm':
      return buildUrl(`/alarms/${id}`);
    case 'Payment':
      return buildUrl(`/payments/${id}`);
    default:
      return buildUrl(`/dashboard`);
  }
};
/**
 *
 * Function to clean payload before send to backend
 * @param {Object} obj Object to clean
 * @param {Array} exceptions Properties that will be ignored when clean the object
 * @param {Array} forced Properties that should be deleted from the object regardless the value
 * @returns {Object} A new Object cleaned just with the necesary properties
 */
export const removeEmpty = (obj, exceptions = [], forced = []) => {
  const newObj = {};

  Object.keys(obj).forEach((key) => {
    if (forced.includes(key)) {
      return;
    }
    if (Array.isArray(obj[key])) {
      newObj[key] = obj[key].map((k) => {
        return removeEmpty(k, exceptions, forced); // recurse
      });
    } else if (obj[key] && typeof obj[key] === 'object' && !exceptions.includes(key)) {
      newObj[key] = removeEmpty(obj[key], exceptions); // recurse
    } else if (exceptions.includes(key)) {
      newObj[key] = obj[key]; // copy value
    } else if (obj[key] != null && obj[key] !== '') {
      newObj[key] = obj[key]; // copy value
    }
  });

  return newObj;
};

export const transformAsyncErrors = (details) => {
  if (!details || !details.length) {
    return {
      timestamp: Date.now(),
    };
  }
  return {
    timestamp: Date.now(),
    ...details?.reduce((obj, e) => {
      obj[e.field] = e.message;
      return obj;
    }, {}),
  };
};

export const getResponseLabel = (subject, template) => {
  const response =
    template && template.responses
      ? template.responses.find((response) => response.subject === subject)
      : null;
  return response ? response.subject_external : null;
};

export const getResponse = (subject, form) => {
  const response = form?.responses
    ? form?.responses.find((response) => response.subject === subject)
    : null;

  if (response) {
    response.label = getResponseLabel(subject, form?.form_template);
  }
  return response;
};

export const getResponseArray = (subject, form) => {
  const label = getResponseLabel(subject, form);
  const responses =
    form && form.responses
      ? form.responses.filter((response) => response.subject === subject)
      : null;
  if (responses) {
    responses.forEach((response) => (response.label = label));
  }
  return responses;
};

/**
 * Method for rounding to whole number with n decimal
 * @param {number} value
 * @param {number} decimals
 */
export const round = (value, decimals) => {
  return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
};

export const getLocaleDatetimeFormat = (locale = 'en_US') => {
  const selectedLocale = locales?.find((l) => l?.locale === locale);
  if (selectedLocale) {
    return selectedLocale?.format;
  }
  return locales[0]?.format || 'MM/DD/YYYY';
};

export const getLocaleDatetimeFormatLower = (locale = 'en_US') => {
  return getLocaleDatetimeFormat(locale)?.replaceAll('D', 'd').replaceAll('Y', 'y');
};

export const formatDate = (date, tz) => {
  return new Date(moment(date).tz(tz).format(`MM/DD/YYYY HH:mm:ss`));
};

export const getRecurringPayment = (pricing) => {
  let payment = 0;
  if (pricing) {
    payment = sumBy(pricing, (price) => {
      const items = price.invoice_item_type;
      if (items && items.pricing_type && items.pricing_type.name === 'SUBSCRIPTIONPERIOD') {
        return price.unit_price;
      }
      return 0;
    });
  }
  return '$' + (payment / 100).toFixed(2);
};

export const toTitleCase = (str = '') => {
  if (!str) return '';
  return str.replace(/[-_]/g, ' ').replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

export const getPowertrains = () => {
  return [
    { value: 'EV', label: i18n.t('vehicle_types.electric') },
    { value: 'HEV', label: i18n.t('vehicle_types.hybrid') },
    { value: 'ICE', label: i18n.t('vehicle_types.gasoline') },
    { value: 'FCEV', label: i18n.t('vehicle_types.H2_fuel_cell') },
    { value: 'PHEV', label: i18n.t('vehicle_types.plugin_hybrid') },
    { value: 'MANUAL', label: i18n.t('vehicle_types.manual') },
  ];
};

export const buildUrl = (path, org) => {
  const orgSlug = window.location?.pathname?.split('/')[1] || sessionStorage.getItem('org_slug');

  return `/${org || orgSlug}${path}`;
};

export const hexToRGB = (hex, alpha) => {
  if (!hex?.includes('#')) return hex;
  var r = parseInt(hex.slice(1, 3), 16),
    g = parseInt(hex.slice(3, 5), 16),
    b = parseInt(hex.slice(5, 7), 16);
  return alpha ? `rgba(${r}, ${g}, ${b}, ${alpha})` : `rgba(${r}, ${g}, ${b})`;
};

export const getSourceLink = (type, id, className) => {
  const label = `${type} ${i18n.t('common.id')} #${id}`;
  switch (type) {
    case 'ReservationDriver':
      return (
        <Link to={buildUrl(`/reservations/${id}`)}>
          <span className={className || ''}>{label}</span>
        </Link>
      );
    case 'Vehicle':
      return (
        <Link to={buildUrl(`/vehicles/${id}`)}>
          <span className={className || ''}>{label}</span>
        </Link>
      );
    case 'Driver':
      return (
        <Link to={buildUrl(`/customers/${id}`)}>
          <span className={className || ''}>{label}</span>
        </Link>
      );
    case 'User':
      return (
        <Link to={buildUrl(`/customers/${id}`)}>
          <span className={className || ''}>{label}</span>
        </Link>
      );
    case 'Invoice':
      return (
        <Link to={buildUrl(`/invoices/${id}`)}>
          <span className={className || ''}>{label}</span>
        </Link>
      );
    case 'Subscription':
      return (
        <Link to={buildUrl(`/subscriptions/${id}`)}>
          <span className={className || ''}>{label}</span>
        </Link>
      );
    case 'ConditionalInstance':
      return (
        <Link to={buildUrl(`/alarms/${id}`)}>
          <span className={className || ''}>{label}</span>
        </Link>
      );
    case 'Payment':
      return (
        <Link to={buildUrl(`/payments/${id}`)}>
          <span className={className || ''}>{label}</span>
        </Link>
      );
    default:
      return label;
  }
};
export const getDateTimezoneFormat = (format, timezone) => {
  if (timezone) {
    const tzOffset = moment.utc().tz(timezone);
    if (tzOffset.isValid()) {
      return `${format} ${tzOffset.format('Z')}`;
    }
  }
  return format;
};

export const getQueryStringParams = (str) => {
  const query = qs.parse(str);
  let _params = {};
  if (Object.keys(query).length) {
    _params = query;
  }
  return _params;
};

export const truncateKeywordSpaces = (keyword) => {
  if (keyword) {
    const newKeyword = keyword?.toString()?.split(' ');
    newKeyword.length = Math.min(newKeyword.length, 3);
    return newKeyword.join(' ');
  }
  return keyword;
};

export const parseGoogleMapsURL = (url = '') => {
  const queryStr = url?.split('?')?.[1] || '';
  const gmData = getQueryStringParams(queryStr);
  if (gmData?.libraries) {
    gmData.libraries = [gmData.libraries || 'places'];
  }
  return gmData;
};

const styles = makeStyles((theme) => ({
  item: {
    fontWeight: 500,
  },
  link: {
    fontWeight: 500,
    color: theme.palette.primary.main,
  },
}));

const getUserLink = (item, user) => {
  const classes = styles();
  const module = item?.user?.is_customer ? 'customers' : 'employees';
  const userLink = item.user ? (
    <Link to={buildUrl(`/${module}/${item.user.id}`)}>
      <span className={classes.link}>{user}</span>
    </Link>
  ) : (
    user
  );
  return userLink;
};

const getLink = (logItem, type, key, value) => {
  const classes = styles();
  const val = `${logItem?.[key] || ''}`;
  const itemString = <span className={classes.item}>{val}</span>;

  if (logItem[key] && logItem[value]) {
    switch (logItem[type]) {
      case 'ReservationDriver':
        return (
          <Link to={buildUrl(`/reservations/${logItem[value]}`)}>
            <span className={classes.link}>{itemString}</span>
          </Link>
        );
      case 'Vehicle':
        return (
          <Link to={buildUrl(`/vehicles/${logItem[value]}`)}>
            <span className={classes.link}>{itemString}</span>
          </Link>
        );
      case 'Driver':
        return (
          <Link to={buildUrl(`/customers/${logItem[value]}`)}>
            <span className={classes.link}>{itemString}</span>
          </Link>
        );
      case 'Invoice':
        return (
          <Link to={buildUrl(`/invoices/${logItem[value]}`)}>
            <span className={classes.link}>{itemString}</span>
          </Link>
        );
      case 'Subscription':
        return (
          <Link to={buildUrl(`/subscriptions/${logItem[value]}`)}>
            <span className={classes.link}>{itemString}</span>
          </Link>
        );
      case 'ConditionalInstance':
        return (
          <Link to={buildUrl(`/alarms/${logItem[value]}`)}>
            <span className={classes.link}>{itemString}</span>
          </Link>
        );
      case 'Payment':
        return (
          <Link to={buildUrl(`/payments/${logItem[value]}`)}>
            <span className={classes.link}>{itemString}</span>
          </Link>
        );
      default:
        return itemString;
    }
  }
};

export const getEventDescription = (
  event,
  options = { showUser: true, useLinks: true, showTarget: true }
) => {
  const { showUser, useLinks, showTarget } = options;
  const organizationHasPartnership = useSelector(
    (state) => state.config.settings?.core?.partnership?.enabled || false
  );
  // TODO: Fix payload in the BE
  if (
    organizationHasPartnership &&
    (event?.extra_target_type === 'OwnerVehicleGroup' || event?.target_type === 'OwnerVehicleGroup')
  ) {
    event.extra_target_string = event.extra_target_string?.replace('VehicleGroup', 'Fleet');
    event.target_string = event.target_string?.replace('VehicleGroup', 'Fleet');
  }
  const user = event.user ? (
    event.user.first_name ? (
      <span>{`${event.user.first_name} ${event.user.last_name}`}</span>
    ) : (
      `${i18n.t('common.user')} ${event.user.id}`
    )
  ) : (
    i18n.t('common.system')
  );

  const userLink = useLinks ? getUserLink(event, user) : user;
  const targetLink =
    (useLinks
      ? getLink(event, 'target_type', 'target_string', 'target_id')
      : event?.target_string) || '';
  const info = event.info || '';
  const extraTargetString =
    (useLinks
      ? getLink(event, 'extra_target_type', 'extra_target_string', 'extra_target_id')
      : event?.extra_target_string) || '';
  const extraInfo = event.extra_info || '';

  return (
    <>
      {showUser ? userLink : null}
      {` ${event?.action} `}
      {showTarget ? targetLink : null}
      {` ${info} `}
      {`${event?.extra_action || ''} `}
      {extraTargetString}
      {` ${extraInfo}`}
    </>
  );
};

export const createStripeCreditCardToken = async (cardInput, STRIPE_PUBLISHABLE_KEY) => {
  let parts = cardInput.expiry.split('/');
  let expiryMonth = parts[0];
  let expiryYear = parts[1];
  const card = {
    'card[name]': cardInput.name,
    'card[number]': cardInput.number.replace(/ /g, ''),
    'card[exp_month]': expiryMonth,
    'card[exp_year]': expiryYear,
    'card[cvc]': cardInput.cvc,
    'card[address_zip]': cardInput.zipcode,
  };
  try {
    const response = await fetch('https://api.stripe.com/v1/tokens', {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: `Bearer ${STRIPE_PUBLISHABLE_KEY}`,
      },
      method: 'post',
      body: Object.keys(card)
        .map((key) => key + '=' + card[key])
        .join('&'),
    });
    return await response.json();
  } catch (error) {
    return { error };
  }
};

export const createStripeBankToken = async (accountInput, STRIPE_PUBLISHABLE_KEY) => {
  const bankAccount = {
    'bank_account[country]': 'US',
    'bank_account[currency]': 'usd',
    'bank_account[account_holder_type]': accountInput.is_company ? 'company' : 'individual',
    'bank_account[account_holder_name]': accountInput.account_holder_name,
    'bank_account[routing_number]': accountInput.routing_number,
    'bank_account[account_number]': accountInput.account_number,
  };
  try {
    const response = await fetch('https://api.stripe.com/v1/tokens', {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: `Bearer ${STRIPE_PUBLISHABLE_KEY}`,
      },
      method: 'post',
      body: Object.keys(bankAccount)
        .map((key) => key + '=' + bankAccount[key])
        .join('&'),
    });
    return await response.json();
  } catch (error) {
    return { error };
  }
};

export const parseInputNumber = (val) => Math.abs((val * 100).toFixed(2));

export const clearStorageItems = function () {
  localStorage.removeItem('unique_id');
  sessionStorage.removeItem('org_slug');
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('reservation_engine');
};

export const getValidPartnershipStates = (currentStatus, orgType, sharingType = 'FAAS') => {
  let allowActivate = false,
    allowReject = false,
    allowCancel = false,
    allowRemove = false,
    allowOnHold = false;
  if (sharingType === 'FAAS') {
    /// FAAS flows
    // Allow if the requester is a owner and the status is REQUESTED or REJECTED
    allowActivate =
      (currentStatus === 'REQUESTED' && orgType === 'msOwnerOrg') ||
      (currentStatus === 'REJECTED' && orgType === 'msOwnerOrg');
    // Allow if the requester is a owner and the status is a REQUESTED
    allowReject = currentStatus === 'REQUESTED' && orgType === 'msOwnerOrg';
    // Allow if the requester is a owner and the status is CANREQUESTED
    allowCancel = currentStatus === 'CANREQUESTED' && orgType === 'msOwnerOrg';
    // Allow if the requester is a service and the status is ACTIVE
    allowRemove = currentStatus === 'ACTIVE' && orgType === 'msServiceOrg';
  } else if (sharingType === 'FFB') {
    /// FFB flows
    // Allow if the requester is a owner and the status is REQUESTED or REJECTED
    allowActivate = currentStatus === 'ONHOLD' && orgType === 'msOwnerOrg';
    // Allow if the requester is a owner and the status is CANREQUESTED
    allowCancel =
      (currentStatus === 'ONHOLD' || currentStatus === 'ACTIVE') && orgType === 'msOwnerOrg';
    // Allow if the requester is a owner and status ACTIVE
    allowOnHold = currentStatus === 'ACTIVE' && orgType === 'msOwnerOrg';
  }

  return {
    allowActivate,
    allowReject,
    allowCancel,
    allowRemove,
    allowOnHold,
    disabled: !allowActivate && !allowRemove && !allowCancel && !allowReject && !allowOnHold,
  };
};

export const generateFilterOptions = (match = 'start', key) => {
  createFilterOptions({
    matchFrom: match,
    stringify: (option) => option[key],
  });
};

/**
 * Check if the response is a cancel error
 * @param {*} response
 * @returns
 */

export const isCancel = (response) => axios.isCancel(response?.originalError);

export const getPrivilegesList = () => {
  const privileges = useSelector((state) => state?.user?.permissions || {});
  return privileges;
};

export const getSideBarConfig = ({ category, label }) => {
  const indexCategory = routes.map((categories) => categories.title || '').indexOf(category);
  const children = routes[indexCategory]?.children;
  const indexChildCategory = children?.map((child) => child.label || '').indexOf(label);

  return {
    privilege:
      typeof indexChildCategory === 'number' ? children[indexChildCategory]?.privilege : undefined,
    configuration:
      typeof indexChildCategory === 'number'
        ? children[indexChildCategory]?.configuration
        : undefined,
  };
};

export const getConfigurationsList = () => {
  const configurations = useSelector((state) => state?.config?.settings?.core || {});
  return configurations;
};

/**
 *
 * Function to check if current user is allowed to perform actions
 * @param {Object} privilege privilege to check
 * @param {Object} configuration config to check
 * @param {String} privilege.do action to check in privilege
 * @param {String} privilege.on name of the privilege to check
 * @param {String} configuration.name name of the configuration to check
 * @param {Object} configuration.is action to check in configuration
 * @returns {Boolean} true or false if configuration and privileges are allowed
 */

export const userIsAllowed = ({
  privilege = {
    do: '',
    on: '',
  },
  configuration = {
    name: '',
    is: '',
  },
  privileges,
  configurations,
}) => {
  let allowedPrivilege = privileges[privilege.on] || false;
  let allowedConfiguration = configurations[configuration.name] || false;

  if (privilege.on === '') allowedPrivilege = true;
  if (configuration.name === '') allowedConfiguration = true;
  if (privilege.on === '' && configuration.name === '') {
    allowedPrivilege = false;
    allowedConfiguration = false;
  }

  allowedPrivilege =
    allowedPrivilege &&
    (allowedPrivilege === true ||
      allowedPrivilege[0] === '*' ||
      allowedPrivilege.includes(privilege.do));
  allowedConfiguration =
    allowedConfiguration &&
    (allowedConfiguration === true ||
      (configurations.hasOwnProperty(configuration?.name) &&
        configurations[configuration?.name][configuration?.is] === true));

  return allowedConfiguration && allowedPrivilege;
};

export const toMinutes = ({ magnitude, units }) => {
  switch (units) {
    case 'min':
      return +magnitude;
    case 'hr':
      return magnitude * 60;
    case 'hour':
      return magnitude * 60;
    case 'day':
      return magnitude * 60 * 24;
    case 'week':
      return magnitude * 60 * 24 * 7;
    case 'month':
      return magnitude * 60 * 24 * 30;
    default:
      return magnitude / 10;
  }
};

export const checkSameBuffer = (bufferA, bufferB) => {
  if (bufferA.is_default || bufferB.is_default) return false;
  return toMinutes(bufferA?.time_range) === toMinutes(bufferB?.time_range);
};

export const compareBuffer = (bufferA, bufferB) => {
  const compareBuffers =
    toMinutes(bufferA.time_range || { magnitude: 100, units: 'month' }) -
    toMinutes(bufferB.time_range || { magnitude: 100, units: 'month' });
  return compareBuffers;
};

export const unitsPlural = (magnitude, units, abbrevation = false) => {
  const unitKey = `units${abbrevation ? '_abbrevation' : ''}.${units}`;
  const unitTranslation = i18n.t(unitKey);

  return magnitude === 1 ? unitTranslation : `${unitTranslation}s`;
};

/**
 * Get the reservation engine version configured for actual org and adds the prefix `rem/` in
 * the URL selected.
 * @param {string} url
 * @returns {string} the URL for new REM API
 */
export const validateReservationEngineVersion = (url) => {
  const reservationEngineVersion = sessionStorage.getItem('reservation_engine');
  if (reservationEngineVersion === 'V2') return `/rem${url}`;
  return url;
};

export const validateReservationEngineVersionMultiUrl = (urls) => {
  const reservationEngineVersion = sessionStorage.getItem('reservation_engine')?.toUpperCase();
  return urls[reservationEngineVersion];
};

export const canAccess = (item) => {
  const rer = sessionStorage.getItem('reservation_engine')?.toUpperCase();
  return (
    ((item.can_access || item.canAccess) && rer == 'V1') || (rer == 'V2' && item?.user?.first_name)
  );
};

export const getSourceItemString = (type, id) => {
  switch (type) {
    case 'ReservationDriver':
      return `${i18n.t('instance.reservation')} ID#${id}`;
    case 'Vehicle':
      return `${i18n.t('instance.vehicle')} ID#${id}`;
    case 'Driver':
      return `${i18n.t('instance.driver')} ID#${id}`;
    case 'Invoice':
      return `${i18n.t('instance.invoice')} ID#${id}`;
    case 'SubscriptionPeriod':
      return `${i18n.t('instance.subscription_period')} ID#${id}`;
    case 'Subscription':
      return `${i18n.t('instance.subscription')} ID#${id}`;
    case 'OwnerVehicleGroup':
      return i18n.t('instance.fleet');
    default:
      return id;
  }
};

export const hasAuthCookie = () => {
  const cookies = new Cookies();
  const oAuthCookie = cookies.get('app.idt');
  return oAuthCookie != null;
};

/**
 * Build the CCP url to navigate
 * @param {*} id The report id in the query params
 * @param {*} report_ts The report timestamp in the query params
 * @returns The final URL to navigate
 */
export const getCCPUrl = (id, report_ts, email) => {
  const { ccpURL } = integrations;
  return `${ccpURL}/report?report_id=${id}&report_ts=${report_ts}&email=${encodeURIComponent(email)}`;
};

/**
 * Open a new tab to start log in flow for Oauth
 * @param {*} broker_slug The broker slug (vendor_slug)
 */
export const redirectOAuthBrokerConnection = (broker_slug, settings, broker_name = null) => {
  const settingsMap = Object.fromEntries(settings.map(({ name, value }) => [name, value]));

  const {
    oauth_url: oauthUrl,
    callback_url: IglooCallbackUrl,
    ...filteredSettingsMap
  } = settingsMap;

  const callbackUrl = IglooCallbackUrl || getApiUrl() + `${broker_name}/callback`;

  const queryParams = Object.entries({
    ...filteredSettingsMap,
    redirect_uri: callbackUrl,
  })
    .map(([key, value]) => `${key}=${value}`)
    .join('&');

  window.open(`${oauthUrl}?${queryParams}`, '_blank');
};
